import React from "react";
import { NakiStoreFeaturedSectionLoaderTemplate } from "themes/administration/naki-store/components";

class NakiStoreFeaturedSectionLoader extends React.Component {
    render() {
        return <NakiStoreFeaturedSectionLoaderTemplate {...this.props} />;
    }
}

export default NakiStoreFeaturedSectionLoader;
